import { Module } from '@bechtel/types';
import { AppModuleExt } from './types';
import { defineMessage, t } from '@lingui/macro';

export const moduleExtData: AppModuleExt[] = [
  {
    id: '1',
    name: t`Dashboard`,
    permissions: [],
    moduleTypeId: Module.DASHBOARD,
    icon: 'tachometer-fast',
    moduleDescription: defineMessage({
      message: 'View progress, metrics, and weekly work list (uses elements of the Work Package and Planning modules).',
      id: 'View progress, metrics, and weekly work list (uses elements of the Work Package and Planning modules).',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '2',
    name: t`Work Packages`,
    permissions: [],
    moduleTypeId: Module.WORK_PACKAGES,
    icon: 'briefcase',
    moduleDescription: defineMessage({
      message: 'Manage work packages and commodities (requires the use of TEAMWorks).',
      id: 'Manage work packages and commodities (requires the use of TEAMWorks).',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '3',
    name: t`Blocks`,
    permissions: [],
    moduleTypeId: Module.BLOCKS,
    icon: 'exclamation-triangle',
    moduleDescription: defineMessage({
      message: 'Identify objects holding up work in the field.',
      id: 'Identify objects holding up work in the field.',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '4',
    name: t`Planning`,
    permissions: [],
    moduleTypeId: Module.PLANNING,
    icon: 'calendar-day',
    moduleDescription: defineMessage({
      message: 'Create a 3WLA for each crew’s activities in the Work Packages assigned.',
      id: 'Create a 3WLA for each crew’s activities in the Work Packages assigned.',
    }).id,
    showModule: true,
    disabled: false,
  },
  {
    id: '5',
    name: t`Timesheet`,
    permissions: [],
    moduleTypeId: Module.TIMESHEET,
    icon: 'user-clock',
    moduleDescription: defineMessage({
      message: 'Enter and track time (requires the use of eTrack).',
      id: 'Enter and track time (requires the use of eTrack).',
    }).id,
    showModule: true,
    disabled: false,
  },
  {
    id: '6',
    name: t`Crew Change`,
    permissions: [],
    moduleTypeId: Module.CREW_CHANGE,
    icon: 'users-class',
    moduleDescription: defineMessage({
      message: 'Initiate and approve crew change requests (requires the use of eTrack).',
      id: 'Initiate and approve crew change requests (requires the use of eTrack).',
    }).id,
    showModule: true,
    disabled: false,
  },
  {
    id: '7',
    name: t`Testing`,
    permissions: [],
    moduleTypeId: Module.TESTING,
    icon: 'list',
    moduleDescription: defineMessage({
      message: 'Manage pipe pressure testing.',
      id: 'Manage pipe pressure testing.',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '8',
    name: t`Punchlist`,
    permissions: [],
    moduleTypeId: Module.PUNCHLIST,
    icon: 'clipboard-check',
    moduleDescription: defineMessage({
      message: 'Create, manage, and close Construction Work-To-Go, Pre-Test, and Post-Test punch list items.',
      id: 'Create, manage, and close Construction Work-To-Go, Pre-Test, and Post-Test punch list items.',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '9',
    name: t`Notifications`,
    permissions: [],
    moduleTypeId: Module.NOTIFICATIONS,
    icon: 'bell',
    moduleDescription: defineMessage({
      message:
        'Get key notifications in the PipeFighter application (turn individual notifications on/off in Project Admin).',
      id:
        'Get key notifications in the PipeFighter application (turn individual notifications on/off in Project Admin).',
    }).id,
    showModule: true,
    disabled: true,
  },
  {
    id: '10',
    name: t`Reports`,
    permissions: [],
    moduleTypeId: Module.REPORTS,
    icon: 'file-chart-line',
    moduleDescription: defineMessage({
      message: 'Create and download reports.',
      id: 'Create and download reports.',
    }).id,
    showModule: true,
    disabled: false,
  },
  {
    id: '11',
    name: t`Application`,
    permissions: [],
    moduleTypeId: Module.APPLICATION,
    icon: 'file-chart-line',
    moduleDescription: defineMessage({
      message: 'Application',
      id: 'Application',
    }).id,
    showModule: false,
    disabled: true,
  },
  {
    id: '12',
    name: t`Admin`,
    permissions: [],
    moduleTypeId: Module.ADMIN,
    icon: 'file-chart-line',
    moduleDescription: defineMessage({
      message: 'Project Admin',
      id: 'Project Admin',
    }).id,
    showModule: false,
    disabled: true,
  },
  {
    id: '13',
    name: t`Rod Room`,
    permissions: [],
    moduleTypeId: Module.ROD_ROOM,
    icon: 'chimney',
    moduleDescription: defineMessage({
      message: 'Create/View Rod Request, Assign Rod Rooms',
      id: 'Create/View Rod Request, Assign Rod Rooms',
    }).id,
    showModule: true,
    disabled: false,
  },
];
